import { render, staticRenderFns } from "./FundingCompetitionIndex.vue?vue&type=template&id=316e1b1a&"
import script from "./FundingCompetitionIndex.vue?vue&type=script&lang=js&"
export * from "./FundingCompetitionIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports